import { useEffect, useContext, useState } from "react";
import { get, post, remove } from "../../../../adapters/xhr/api";
import Moment from "moment";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import { validateRequired } from "../../../../helpers/Validation";
import { DatePickerFormatedWithLimit } from "../../../../shared/form/DatePickerFormated";
import Modal from "react-modal";
import stylesModal from "./Modal.module.css";
import { useLocation, useParams } from "react-router-dom";
import CommonAddressMap from "../../../../shared/pages/map/CommonAddressMap";
import infoIconSvg from "../../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../../shared/form/InfoPopover";
import {
  validateManualCommonAddress,
  validateManualBuildingMatch,
  validateBuildingFilterSearchType,
  hasFilterSearchTypeMismatch,
  getMatchingBuildings,
} from "../../helpers/commonValidation";
import { getManualCommonBuilding } from "../../helpers/constants";

const PetroleumFacilityForm = ({
  generateOptions,
  residentialUnitTypes,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  ownershipDeedFileInputRef,
  leaseContractFileInputRef,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  constructionLicenseFileInputRef,
  openingBudgetFileInputRef,
  allBookValueFileInputRef,
  setBackendError,
  setSubmissionError,
  setTempFiles,
  unitBuildingMapError,
  setUnitBuildingMapError,
  unitMapError,
  setUnitMapError,
}) => {
  Modal.setAppElement("body");
  const location = useLocation();
  const { id } = useParams();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    updateDeclarationUnit,
    building,
    setBuilding,
    setDeclarationRequest,
    isBuildingEditMode,
    setIsBuildingEditMode,
    isDuplicateRenin,
    setIsDuplicateRenin,
    errorBuilding,
    setErrorBuilding,
    dataMismatchReasonLookup,
    DoYouWantExtraAttachmentsForRequestTypes,
    getLabelById,
    buildingFullAddressDisplay,
    staticGovs,
    buildingDate,
    setBuildingDate,
  } = unifiedTaxDeclarationContext;

  const [burdenActivityTypes, setBurdenActivityTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteOther, setShowDeleteOther] = useState(false);
  const [fileErrors, setFileErrors] = useState({});
  const [idToBeDeleted, setIdToBeDeleted] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [staticBuilding, setStaticBuilding] = useState(null);
  const [isAddBuildingButtonDisabled, setIsAddBuildingButtonDisabled] =
    useState(false);
  const [buildingsBeforeEdit, setBuildingsBeforeEdit] = useState(null);
  const [addBuildingErrorMessage, setAddBuildingErrorMessage] = useState("");
  const [buildingValidFields, setBuildingValidFields] = useState({
    building_type_text: false,
    total_area: false,
    construction_date: false,
  });
  const canEditUnit =
    !declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode;

  useEffect(() => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setBuilding(null);
  }, []);

  useEffect(() => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setUnitMapError("");
  }, [declarationRequest?.filter_search_type_id]);

  const setEachErrorBuilding = (key, value) => {
    setErrorBuilding((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    const allValid = Object.values(buildingValidFields).every(Boolean);
    setBuildingValidFields(allValid);
  }, [buildingValidFields]);

  const handleUpdateBuilding = (pc, c, field, value) => {
    setBuilding({
      ...building,
      [field]: value,
    });
  };

  useEffect(() => {
    if (
      parseInt(declarationRequest?.unit?.used_land_area) >
      parseInt(declarationRequest?.unit?.total_land_area)
    ) {
      setError(
        "used_land_area",
        "يجب أن تكون مساحة الأرض المستغلة أصغر من أو تساوي مساحة الأرض الكلية",
      );
    } else {
      setError("used_land_area", "");
    }
  }, [
    declarationRequest?.unit?.used_land_area,
    declarationRequest?.unit?.total_land_area,
  ]);

  const formFields = ({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    stylesRequestData,
  }) => [
    {
      type: "input",
      colClass: "col-md-4",
      name: "facility_name",
      labelText: "اسم المنشأة",
      placeholder: "ادخل اسم المنشأة..",
      labelHtmlFor: "facility_name",
      inputType: "text",
      maxLength: 100,
      allowedPattern: /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
      value: declarationRequest?.unit?.facility_name,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.facility_name,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "usage_type",
      labelText: "نوع الإستخدام ",
      placeholder: "ادخل نوع الإستخدام ..",
      maxLength: 100,
      labelHtmlFor: "usage_type",
      inputType: "text",
      allowedPattern: /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
      value: declarationRequest?.unit?.usage_type,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.usage_type,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "total_land_area",
      labelText: "مساحة الأرض الكلية",
      placeholder: "ادخل مساحة الأرض الكلية..",
      labelHtmlFor: "total_land_area",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.total_land_area || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.total_land_area,
      stylesRequestData,
      required: true,
      /* popover: {
        content:
          "يتم تحديد المساحة الكلية للأرض ثم مساحة الأرض المستغلة فعلياً.",
      }, */
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "used_land_area",
      labelText: "مساحة الأرض المستغلة ",
      placeholder: "ادخل مساحة الأرض المستغلة ..",
      labelHtmlFor: "used_land_area",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.used_land_area || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.used_land_area,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "land_book_value",
      labelText: "التكلفة الدفترية للأرض",
      placeholder: "ادخل التكلفة الدفترية للأرض..",
      labelHtmlFor: "land_book_value",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.land_book_value || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.land_book_value,
      stylesRequestData,
      required: false,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "buildings_count",
      labelText: "عدد المباني",
      placeholder: "ادخل عدد المباني..",
      labelHtmlFor: "buildings_count",
      inputType: "number",
      min: 1,
      step: 1,
      maxLength: 10,
      allowedPattern: /^[1-9]\d{0,9}$/,
      value: declarationRequest?.unit?.buildings_count || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.buildings_count
        ? error_new_user?.buildings_count
        : addBuildingErrorMessage,
      stylesRequestData,
      required: true,
    },
  ];

  const handleBuildingDateChange = (parentCompenent, compenent, key, value) => {
    setBuildingDate(value);
    setBuilding((prev) => ({
      ...prev,
      construction_date: Moment(value).format("yyyy-MM-DD"),
    }));
  };

  const validateBeforeSubmitBuilding = () => {
    let isFormValid = true;
    let isManualValid = true;

    if (!validateRequired(building?.building_type_text)) {
      setBuildingValidFields((prev) => ({
        ...prev,
        building_type_text: false,
      }));
      setEachErrorBuilding("building_type_text", "يجب ادخال نوع المبنى");
      isFormValid = false;
    } else {
      setEachErrorBuilding("building_type_text", "");
      setBuildingValidFields((prev) => ({
        ...prev,
        building_type_text: true,
      }));
    }

    if (!validateRequired(building?.total_area)) {
      setBuildingValidFields((prev) => ({
        ...prev,
        total_area: false,
      }));
      setEachErrorBuilding("total_area", "يجب ادخال مساحة المبنى");
      isFormValid = false;
    } else {
      setEachErrorBuilding("total_area", "");
      setBuildingValidFields((prev) => ({
        ...prev,
        total_area: true,
      }));
    }

    if (
      !validateRequired(building?.construction_date) ||
      !validateRequired(buildingDate)
    ) {
      setBuildingValidFields((prev) => ({
        ...prev,
        construction_date: false,
      }));
      setEachErrorBuilding(
        "construction_date",
        "يجب اختيار تاريخ انشاء المبنى ",
      );
      isFormValid = false;
    } else {
      setEachErrorBuilding("construction_date", "");
      setBuildingValidFields((prev) => ({
        ...prev,
        construction_date: true,
      }));
    }

    if (building?.main_building !== 1) {
      if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
        if (
          !validateRequired(
            declarationRequest?.unit?.building?.is_map_address_matching,
          )
        ) {
          setBuildingValidFields((prev) => ({
            ...prev,
            is_map_address_matching: false,
          }));
          setEachErrorBuilding("is_map_address_matching", "يجب اختيار إجابة");
          isFormValid = false;
        } else {
          // Rule 2: if no known_build_num AND is_map_address_matching === 1 → special error
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.buildingProfile?.number,
            ) &&
            parseInt(
              declarationRequest?.unit?.building?.is_map_address_matching,
            ) === 1
          ) {
            setBuildingValidFields((prev) => ({
              ...prev,
              is_map_address_matching: false,
            }));
            setEachErrorBuilding(
              "is_map_address_matching",
              "لا يمكن الإستمرار بالإجابة “نعم” لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه",
            );
            isFormValid = false;
          } else {
            // If known_build_num is provided, clear its error
            setBuildingValidFields((prev) => ({
              ...prev,
              is_map_address_matching: true,
            }));
            setEachErrorBuilding("is_map_address_matching", "");
          }
        }

        if (
          parseInt(
            declarationRequest?.unit?.building?.is_map_address_matching,
          ) === 2
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.mismatch_reason_id,
            )
          ) {
            setBuildingValidFields((prev) => ({
              ...prev,
              mismatch_reason_id: false,
            }));
            setEachErrorBuilding("mismatch_reason_id", "يجب اختيار إجابة");
            isFormValid = false;
          } else {
            setEachErrorBuilding("mismatch_reason_id", "");
            setBuildingValidFields((prev) => ({
              ...prev,
              mismatch_reason_id: true,
            }));
          }
        }

        if (
          !validateRequired(
            declarationRequest?.unit?.building?.buildingProfile?.number,
          )
        ) {
          if (
            !validateRequired(
              declarationRequest?.unit?.building?.known_build_num,
            )
          ) {
            setBuildingValidFields((prev) => ({
              ...prev,
              known_build_num: false,
            }));
            setEachErrorBuilding(
              "known_build_num",
              "يجب إدخال رقم العقار/المبنى المتعارف عليه",
            );
            isFormValid = false;
          } else {
            setEachErrorBuilding("known_build_num", "");
            setBuildingValidFields((prev) => ({
              ...prev,
              known_build_num: true,
            }));
          }
        } else {
          setEachErrorBuilding("known_build_num", "");
          setBuildingValidFields((prev) => ({
            ...prev,
            known_build_num: true,
          }));
        }
      } else {
        isManualValid = validateManualCommonAddress(
          declarationRequest,
          validateRequired,
          setError,
          setValidFields,
          false,
        );
      }
    } else {
      if (parseInt(declarationRequest?.unit?.filter_search_type_id) === 3) {
        isManualValid = validateManualCommonAddress(
          declarationRequest,
          validateRequired,
          setError,
          setValidFields,
          true,
        );
      } else {
        isManualValid = true;
      }
    }

    return isFormValid && isManualValid;
  };

  const fields = formFields({
    declarationRequest,
    error_new_user,
    residentialUnitTypes,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  });

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: response?.data?.data,
        // }));
        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({ ...prev, [key]: "" }));
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: null,
        // }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  useEffect(() => {
    if (!parseInt(declarationRequest?.unit?.buildings_count)) {
      setIsAddBuildingButtonDisabled(true);
    } else if (
      getMatchingBuildings(declarationRequest)?.length ===
      parseInt(declarationRequest?.unit?.buildings_count || 1)
    ) {
      setIsAddBuildingButtonDisabled(true);
    } else if (
      getMatchingBuildings(declarationRequest)?.length >=
      parseInt(declarationRequest?.unit?.buildings_count || 1)
    ) {
      setIsAddBuildingButtonDisabled(true);
    } else {
      setIsAddBuildingButtonDisabled(false);
    }
  }, [
    declarationRequest?.unit?.buildings_count,
    declarationRequest?.unit?.buildings,
    getMatchingBuildings(declarationRequest),
  ]);

  useEffect(() => {
    if (
      parseInt(declarationRequest?.unit?.buildings_count || 1) <
      getMatchingBuildings(declarationRequest)?.length
    ) {
      setAddBuildingErrorMessage(
        "يجب أن يكون عدد المباني أكبر من إجمالي المباني المُدخلة أو مساويًا لها",
      );
    } else if (
      parseInt(declarationRequest?.unit?.buildings_count || 1) ===
      getMatchingBuildings(declarationRequest)?.length
    ) {
      setAddBuildingErrorMessage("");

      setIsAddBuildingButtonDisabled(true);
    } else {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(false);
    }
  }, [declarationRequest?.unit?.buildings_count]);

  useEffect(() => {
    if (!declarationRequest?.unit?.building?.buildingProfile) {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(true);
    } else {
      setAddBuildingErrorMessage("");
      setIsAddBuildingButtonDisabled(false);
    }
  }, [declarationRequest?.unit?.building?.buildingProfile]);

  useEffect(() => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings_count: declarationRequest?.unit?.buildings_count || 1,
      },
    }));
  }, []);

  const canAppendBuilding = (newBuildingProfile, existingBuildings = []) => {
    if (!newBuildingProfile?.renin) return false; // must have renin

    if (parseInt(building?.mismatch_reason_id) === 3) {
      return true;
    } else {
      return !existingBuildings
        .filter((b) => parseInt(b?.mismatch_reason_id) !== 3)
        .some((b) => b?.buildingProfile?.renin == newBuildingProfile.renin);
    }
  };

  const validateBuildingProfileMatch = (unitProfile, buildingProfile) => {
    if (!unitProfile || !buildingProfile) return false;

    const unitIds = unitProfile.address_ids ?? {};
    const buildingIds = buildingProfile.address_ids ?? {};

    const keysToCheck = [
      "district_id",
      "goveronrate_id",
      "city_id",
      "policestation_id",
    ];

    // return true only if all 4 values are equal
    return keysToCheck.every((key) => unitIds[key] === buildingIds[key]);
  };

  const handleAddBuilding = async (shouldShowModal) => {
    setIsSubmitting(true);
    setEachErrorBuilding("known_build_num", "");
    let isValid = false;

    const isBuildingHasDifferentSearchType = validateBuildingFilterSearchType(
      declarationRequest,
      declarationRequest?.unit?.filter_search_type_id,
    );

    if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
      const isMatching = validateBuildingProfileMatch(
        declarationRequest?.unit?.buildingProfile,
        declarationRequest?.unit?.building?.buildingProfile,
      );
      if (!isMatching) {
        setIsDuplicateRenin(
          "لا يمكن إضافة المبنى لأنه خارج نطاق موقع المبنى الرئيسي للمنشأة",
        );
        setIsSubmitting(false);
        return;
      } else {
        setIsDuplicateRenin("");
      }

      if (
        !canAppendBuilding(
          declarationRequest?.unit?.building?.buildingProfile,
          getMatchingBuildings(declarationRequest),
        )
      ) {
        setIsDuplicateRenin("لقد تمت إضافة هذا المبنى من قبل");
        isValid = false;
        setIsSubmitting(false);
        return;
      } else {
        setIsDuplicateRenin("");
        isValid = true;
      }

      if (
        !validateRequired(
          declarationRequest?.unit?.building?.buildingProfile?.renin,
        )
      ) {
        setUnitBuildingMapError("هذا العقار غير متاح برجاء اختيار عقار آخر");
      } else {
        setUnitBuildingMapError("");
        isValid = true;
      }

      if (!validateRequired(declarationRequest?.unit?.buildingProfile?.renin)) {
        setUnitMapError("هذا العقار غير متاح برجاء اختيار عقار آخر");
      } else {
        isValid = true;
        setUnitMapError("");
      }

      if (parseInt(building?.main_building) === 1) {
        const hasProfileNumber =
          !!declarationRequest?.unit?.buildingProfile?.number;
        const hasKnownNumber = !!declarationRequest?.unit?.known_build_num;

        if (!hasProfileNumber && !hasKnownNumber) {
          setIsDuplicateRenin(
            "لا يمكن إضافة المبنى لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه في قسم بيانات الموقع",
          );
          isValid = false;
        } else {
          setIsDuplicateRenin("");
          isValid = true;
        }
      }
    } else {
      isValid = true;
    }

    error_new_user?.buildings_count && setError("buildings_count", "");

    const isBuildingFormValid = validateBeforeSubmitBuilding();

    if (
      parseInt(building?.main_building) !== 1 &&
      building !== null &&
      building !== undefined
    ) {
      building.manual_known_build_num =
        building?.building_manual_known_build_num;
    }

    if (isBuildingFormValid && isValid) {
      if (!isBuildingHasDifferentSearchType && shouldShowModal) {
        return setShowDeleteOther(true);
      }
      building.id = building.id || Math.random();

      if (declarationRequest?.unit?.id) {
        const url = `api/declaration-system/declarations/${id}/units/petroleum/${declarationRequest?.unit?.id}`;

        if (building?.id < 1) {
          delete building.id;
        }

        const data = {
          buildings_count: declarationRequest?.unit?.buildings_count,
          total_land_area: declarationRequest?.unit?.total_land_area,
          building: {
            ...building,
            ...(parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3
              ? {
                  buildingProfile:
                    declarationRequest?.unit?.building?.buildingProfile,
                  filter_search_type: parseInt(
                    declarationRequest?.unit?.filter_search_type_id,
                  ),
                }
              : getManualCommonBuilding(
                  declarationRequest,
                  building?.main_building ||
                    getMatchingBuildings(declarationRequest)?.length === 0
                    ? 1
                    : 0,
                  building?.id,
                )),
          },
          unit: declarationRequest?.unit,
        };
        try {
          const response = await post(
            url,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            data,
          );

          setDeclarationRequest((prev) => ({
            ...prev,
            unit: {
              ...prev.unit,
              buildings: response?.data?.unit?.buildings,
            },
          }));
        } catch (error) {
          if (error.response?.data?.errors) {
            setSubmissionError(error.response?.data?.errors);
          } else {
            setBackendError(
              error.response?.data?.message ||
                error.response?.data?.data?.message ||
                "خطأ في إرسال البيانات",
            );
          }
          if (isBuildingEditMode && buildingsBeforeEdit) {
            setDeclarationRequest((prev) => ({
              ...prev,
              unit: {
                ...prev.unit,
                buildings: buildingsBeforeEdit,
              },
            }));
          }

          window.scrollTo(0, 0);
        }
      } else {
        setDeclarationRequest((prev) => ({
          ...prev,
          unit: {
            ...prev.unit,
            buildings: [
              ...(prev.unit?.buildings ?? []),
              {
                ...building,
                ...(parseInt(
                  declarationRequest?.unit?.filter_search_type_id,
                ) !== 3
                  ? {
                      buildingProfile:
                        declarationRequest?.unit?.building?.buildingProfile,
                      filter_search_type: parseInt(
                        declarationRequest?.unit?.filter_search_type_id,
                      ),
                    }
                  : getManualCommonBuilding(
                      declarationRequest,
                      building?.main_building ||
                        getMatchingBuildings(declarationRequest)?.length === 0
                        ? 1
                        : 0,
                      building?.id,
                    )),
              },
            ],
          },
        }));
      }
      setBuilding(null);
      setIsBuildingEditMode(false);
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev.unit,
          building: null,
        },
      }));
      setBuildingDate(null);
    }
    setIsSubmitting(false);
  };

  /* const handleCancelBuilding = () => {
    setBuilding(staticBuilding);
    setIsBuildingEditMode(false);
    setIsDuplicateRenin("");
    setEachErrorBuilding("is_map_address_matching", "");

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: [...(prev.unit?.buildings ?? []), staticBuilding],
        building: null,
      },
    }));
    setBuilding(null);
    setBuildingDate(null);
  }; */
  const handleCancelBuilding = () => {
    setIsBuildingEditMode(false);
    setIsDuplicateRenin("");
    setEachErrorBuilding("is_map_address_matching", "");

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: buildingsBeforeEdit || [], // Restore original list
        building: null,
      },
    }));

    setBuilding(null);
    setBuildingDate(null);
    setBuildingsBeforeEdit(null); // cleanup
  };

  const resetErrorMessages = () => {
    setIsDuplicateRenin("");
    setUnitBuildingMapError("");
    setUnitMapError("");
    setBackendError(null);
    setSubmissionError(null);
  };

  const handleDeleteBuilding = async () => {
    const id = idToBeDeleted;
    if (id >= 1) {
      try {
        let url = `api/declaration-system/declarations/${declarationRequest?.id}/units/petroleum/${declarationRequest?.unit?.id}/${id}`;

        await remove(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
      } catch (error) {
        console.error("Failed to delete", error);
      }
    }
    setShowModal(false);
    deleteFromBuildings(id);
  };

  /* const handleEditBuilding = (buildingToBeEdited) => {
    resetErrorMessages();
    setIsBuildingEditMode(true);
    setStaticBuilding(buildingToBeEdited);

    setBuilding(buildingToBeEdited);
    setBuildingDate(
      Moment(buildingToBeEdited?.construction_date, "YYYY-MM-DD").toDate(),
    );
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        building: buildingToBeEdited,
      },
    }));
    deleteFromBuildings(buildingToBeEdited.id);
  }; */
  const handleEditBuilding = (buildingToBeEdited) => {
    if (parseInt(buildingToBeEdited?.main_building) !== 1) {
      buildingToBeEdited.building_manual_known_build_num =
        buildingToBeEdited?.manual_known_build_num ||
        buildingToBeEdited?.building_manual_known_build_num;
    }
    resetErrorMessages();
    setIsBuildingEditMode(true);

    // Save the full list of buildings before we remove anything
    setBuildingsBeforeEdit(getMatchingBuildings(declarationRequest) || []);

    // Safe copy
    setStaticBuilding(JSON.parse(JSON.stringify(buildingToBeEdited)));

    setBuilding(buildingToBeEdited);
    setBuildingDate(
      buildingToBeEdited?.construction_date
        ? Moment(buildingToBeEdited.construction_date, "YYYY-MM-DD").toDate()
        : null,
    );

    // Remove only the building being edited
    setDeclarationRequest((prev) => {
      const buildings = prev.unit?.buildings ?? [];
      const nextBuildings = buildings.filter((b) => b !== buildingToBeEdited);

      return {
        ...prev,
        unit: {
          ...prev.unit,
          buildings: nextBuildings,
          building: buildingToBeEdited,
        },
      };
    });
  };

  const deleteFromBuildings = (id) => {
    setDeclarationRequest((prev) => {
      const buildings = prev.unit?.buildings ?? [];
      const nextBuildings = buildings.filter((b) => b?.id !== id);

      // If nothing changed, return prev to avoid unnecessary re-renders
      if (nextBuildings.length === buildings.length) return prev;

      return {
        ...prev,
        unit: {
          ...prev.unit,
          buildings: nextBuildings,
        },
      };
    });
  };

  const attachedEssentialDocuments = [
    {
      key: "construction_license",
      label: "مرفق التراخيص الإنشائية",
      file: declarationRequest?.unit?.construction_license,
    },
    {
      key: "opening_budget",
      label: "مرفق الميزانية الإفتتاحية",
      file: declarationRequest?.unit?.opening_budget,
    },
    {
      key: "all_book_value",
      label: "مرفق القيمة الدفترية لكافة الأصول",
      file: declarationRequest?.unit?.all_book_value,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  const handleDeleteAllManualBuildings = async () => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        buildings: [],
        hotelUnits: [],
      },
    }));

    handleAddBuilding(false);
    setShowDeleteOther(false);
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف هذا المبني؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteBuilding}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showDeleteOther}
        onRequestClose={() => showDeleteOther(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            في حالة تأكيد إضافة المبنى الرئيسي بإستخدام وسيلة عنوان أخرى غير
            المُدخلة مسبقا سيتم حذف المباني الأخرى نظرا لتغيير طريقة ادخال عنوان
            المبنى الرئيسي للمنشأة - و يجب إعادة استكمال بيانات المبنى الرئيسي
            في قسم وصف المباني ثم إضافة المبنى لإستكمال عملية إضافة العقار
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteAllManualBuildings}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => {
                setShowDeleteOther(false);
                setIsSubmitting(false);
              }}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      <div className="row">
        <div className="d-flex align-items-center mb-4">
          <h4 className={`${stylesRequestData["box-title"]} box-title mb-0`}>
            وصف المباني
          </h4>
        </div>
        {declarationRequest?.viewMode || declarationRequest?.isUnitViewMode ? (
          <></>
        ) : (
          <>
            <CommonAddressMap
              hasNoContainer={true}
              mapType={"building"}
              NoRender={false}
              unitBuildingMapError={unitBuildingMapError}
              setUnitBuildingMapError={setUnitBuildingMapError}
              isMainBuilding={parseInt(building?.main_building) === 1}
            />

            {/* <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="known_build_num"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText="رقم العقار/المبنى المتعارف عليه"
                inputType="text"
                maxLength={100}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="known_build_num_input"
                name="known_build_num"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.known_build_num || ""}
                allowedPattern={
                  /^(?!0)[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                }
                onChange={handleUpdateBuilding}
                pText={errorBuilding.known_build_num}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div> */}

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="building_type_text"
                labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                labelText="نوع المبنى "
                placeholder="ادخل نوع المبنى  .."
                inputType="text"
                maxLength={100}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="building_type_text_input"
                name="building_type_text"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.building_type_text || ""}
                allowedPattern={
                  /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                }
                onChange={handleUpdateBuilding}
                pText={errorBuilding.building_type_text}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="book_value"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText="التكلفة الدفترية للمبنى "
                placeholder="ادخل التكلفة الدفترية للمبنى.."
                inputType="text"
                maxLength={100}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="book_value_input"
                name="book_value"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.book_value || ""}
                allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/}
                onChange={handleUpdateBuilding}
                pText={errorBuilding.book_value}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="total_area"
                labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                labelText=" مساحة المبنى "
                placeholder="ادخل مساحة المبنى.."
                inputType="text"
                maxLength={100}
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="total_area_input"
                name="total_area"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={building?.total_area || ""}
                allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/}
                onChange={handleUpdateBuilding}
                pText={errorBuilding.total_area}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                popover={{
                  content: "إجمالي مساحة المبنى تساوى مسطح الدور × عدد الأدوار",
                }}
              />
            </div>

            {declarationRequest?.viewMode ||
            declarationRequest?.isUnitViewMode ? (
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  value={buildingDate}
                  disabled={true}
                  name="from_date"
                  mb4="mb-4"
                  labelHtmlFor="from_date"
                  labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                  labelText={"تاريخ إنشاء المبنى"}
                  inputType="text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="from_date_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
            ) : (
              <div className="col-lg-4 col-sm-6">
                <DatePickerFormatedWithLimit
                  name="from_date"
                  name_datepicker="from_date"
                  mb4="mb-4"
                  labelHtmlFor="from_date"
                  labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                  labelText="تاريخ إنشاء المبنى"
                  inputType="datePicker"
                  maxDate={
                    new Date(declarationRequest?.created_at) || Moment().toNow
                  }
                  inputClassName="form-control"
                  inputID="construction_date_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={errorBuilding.construction_date}
                  value={buildingDate}
                  placeholderText="تاريخ إنشاء المبنى"
                  onChange={handleBuildingDateChange}
                  isDisabled={
                    declarationRequest?.viewMode ||
                    declarationRequest?.isUnitViewMode
                  }
                />
              </div>
            )}

            <div className="d-flex flex-lg-row flex-column gap-3 align-items-start">
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <button
                    type="button"
                    className={
                      isAddBuildingButtonDisabled || isSubmitting
                        ? stylesRequestData["btn-add-disabled"]
                        : stylesRequestData["btn-add"]
                    }
                    onClick={() => handleAddBuilding(true)}
                    id="submit_request_data"
                  >
                    {isBuildingEditMode ? "حفظ" : "إضافة مبنى"}
                  </button>

                  {!isBuildingEditMode && (
                    <div className="d-inline-flex align-items-center gap-2">
                      <InfoPopover content="لإضافة مبنى آخر برجاء زيادة عدد المباني في قسم بيانات المنشأة">
                        <img
                          src={infoIconSvg}
                          alt="info"
                          width="18"
                          height="18"
                          style={{ display: "block" }}
                        />
                      </InfoPopover>
                    </div>
                  )}
                </div>
              </div>

              {isBuildingEditMode && (
                <div>
                  <button
                    type="button"
                    className={`${stylesRequestData["btn-cancel-building"]}`}
                    onClick={handleCancelBuilding}
                  >
                    إلغاء
                  </button>
                </div>
              )}
            </div>
            <div className="w-100 mt-1 pb-3">
              {isDuplicateRenin !== "" && (
                <p className="text-danger mb-0  me-2 fw-bolder">
                  {isDuplicateRenin}
                </p>
              )}
            </div>
          </>
        )}
      </div>

      {getMatchingBuildings(declarationRequest)?.length > 0 && (
        <>
          <div
            className={`${stylesRequestData["table-responsive"]} table-responsive mb-3`}
          >
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>المحافظة</th>
                  <th>عنوان العقار</th>
                  <th>الرقم القومي العقاري للمبنى</th>
                  {/* <th>رقم العقار/المبنى المتعارف عليه</th> */}
                  <th>العنوان مطابق لعنوان العقار محل الإقرار</th>
                  <th>سبب عدم تطابق البيانات</th>
                  <th>نوع المبنى</th>
                  <th> مساحة المبنى</th>
                  <th> تاريخ إنشاء المبنى</th>
                  <th>التكلفة الدفترية للمبنى</th>

                  {!declarationRequest?.viewMode &&
                    !declarationRequest?.isUnitViewMode && (
                      <>
                        {" "}
                        <th> </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {getMatchingBuildings(declarationRequest)?.length > 0 ? (
                  getMatchingBuildings(declarationRequest)?.map((unit, idx) => (
                    <tr key={unit?.id ?? `unit-${idx}`}>
                      <td data-label="المحافظة">
                        {unit?.buildingProfile?.address?.goveronrate ||
                          unit?.governorate_text ||
                          getLabelById(
                            unit?.manual_governorate_id,
                            staticGovs,
                          ) ||
                          "—"}
                      </td>

                      <td data-label=" عنوان العقار">
                        {(unit?.mismatch_reason_id ||
                          unit?.correct_astrick_colour) && (
                          <span
                            className="mr-1"
                            style={{
                              color:
                                parseInt(unit?.mismatch_reason_id) === 1
                                  ? "green"
                                  : parseInt(unit?.mismatch_reason_id) === 2
                                    ? "blue"
                                    : parseInt(unit?.mismatch_reason_id) === 3
                                      ? "red"
                                      : "orange",
                            }}
                          >
                            *
                          </span>
                        )}
                        {buildingFullAddressDisplay(
                          unit?.buildingProfile,
                          declarationRequest?.unit?.buildings[idx],
                        )}
                      </td>
                      <td data-label="الرقم القومي العقاري للمبنى">
                        {unit?.buildingProfile?.renin ||
                          unit?.manual_renin ||
                          "—"}
                      </td>
                      {/* <td data-label="رقم العقار/المبنى المتعارف عليه">
                        {unit?.known_build_num || "—"}
                      </td> */}
                      <td data-label="العنوان مطابق لعنوان العقار محل الإقرار">
                        {getLabelById(
                          unit?.is_map_address_matching,
                          DoYouWantExtraAttachmentsForRequestTypes,
                        ) || "—"}
                      </td>
                      <td data-label="سبب عدم تطابق البيانات">
                        {getLabelById(
                          unit?.mismatch_reason_id,
                          dataMismatchReasonLookup,
                        ) || "—"}
                      </td>
                      <td data-label="نوع المبنى">
                        {unit?.building_type_text ?? ""}
                      </td>
                      <td data-label="المساحة الإجمالية للمبنى">
                        {unit?.total_area ?? ""}
                      </td>

                      <td data-label=" تاريخ إنشاء المبنى">
                        {Moment.utc(unit?.construction_date).format(
                          "YYYY-MM-DD",
                        ) ?? ""}
                      </td>

                      <td data-label=" التكلفة الدفترية للمبنى">
                        {unit?.book_value ?? "—"}
                      </td>

                      {/* actions */}
                      <td data-label="إجراءات">
                        <div
                          className={`d-flex ${stylesRequestData["action-buttons-small-screen"]}`}
                        >
                          <div
                            className={`${stylesRequestData["action-buttons"]}`}
                          >
                            {canEditUnit && (
                              // parseInt(unit?.main_building) !== 1 &&
                              <>
                                <button
                                  type="button"
                                  className={`${stylesRequestData["btn-edit"]}`}
                                  onClick={() => handleEditBuilding(unit)}
                                  title="تعديل الوحدة"
                                  disabled={
                                    isBuildingEditMode ||
                                    hasFilterSearchTypeMismatch(
                                      declarationRequest,
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </button>

                                {getMatchingBuildings(declarationRequest)
                                  ?.length > 1 &&
                                  parseInt(unit?.main_building) !== 1 && (
                                    <button
                                      type="button"
                                      className={`${stylesRequestData["btn-delete-icon"]}`}
                                      onClick={() => {
                                        setIdToBeDeleted(unit?.id);
                                        setShowModal(true);
                                        setBuilding(null);
                                        setDeclarationRequest((prev) => ({
                                          ...prev,
                                          unit: {
                                            ...prev.unit,
                                            building: {
                                              ...prev.unit?.building,
                                              buildingProfile: null,
                                            },
                                          },
                                        }));
                                        setBuildingDate(null);
                                      }}
                                      title="حذف المبني"
                                      disabled={isBuildingEditMode}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </button>
                                  )}
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {/* Adjust colSpan to match your actual number of columns */}
                    <td colSpan={15} className="h5 text-center">
                      لا يوجد وحدات مباني
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="col-md-4">
            <InputElement
              fileInputRef={constructionLicenseFileInputRef}
              mb4="mb-4"
              key={`agency-${fileInputKeys.construction_license}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="construction_license"
              labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
              labelText="صورة من التراخيص الإنشائية"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="construction_license_input"
              name="construction_license"
              fileName={
                declarationRequest?.unit?.construction_license
                  ?.original_file_name || "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["construction_license"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.construction_license !== null
                  ? true
                  : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit(
                  "",
                  "",
                  "construction_license",
                  null,
                );
                if (constructionLicenseFileInputRef?.current) {
                  constructionLicenseFileInputRef.current.value = null;
                }
              }}
            />
          </div>
          <div className="col-md-4">
            <InputElement
              fileInputRef={openingBudgetFileInputRef}
              mb4="mb-4"
              key={`agency-${fileInputKeys.opening_budget}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="opening_budget"
              labelClassName={`${stylesRequestData["form-label"]} form-label  `}
              labelText="صورة من الميزانية الإفتتاحية"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="opening_budget_input"
              name="opening_budget"
              fileName={
                declarationRequest?.unit?.opening_budget?.original_file_name ||
                "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["opening_budget"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.opening_budget !== null ? true : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit("", "", "opening_budget", null);
                if (openingBudgetFileInputRef?.current) {
                  openingBudgetFileInputRef.current.value = null;
                }
              }}
            />
          </div>

          <div className="col-md-4">
            <InputElement
              fileInputRef={allBookValueFileInputRef}
              mb4="mb-4"
              key={`agency-${fileInputKeys.all_book_value}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="all_book_value"
              labelClassName={`${stylesRequestData["form-label"]} form-label  `}
              labelText="صورة بالقيمة الدفترية لكافة الأصول"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="all_book_value_input"
              name="all_book_value"
              fileName={
                declarationRequest?.unit?.all_book_value?.original_file_name ||
                "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["all_book_value"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.all_book_value !== null ? true : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit("", "", "all_book_value", null);
                if (allBookValueFileInputRef?.current) {
                  allBookValueFileInputRef.current.value = null;
                }
              }}
            />
          </div>
        </>
      )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center py-2">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default PetroleumFacilityForm;
